import * as React from "react";
import ServicioPadron from "../../../servicios/Padron";
import SolicitudConsultaPadron from "../../../Contenedores/Padron/SolicitudConsultaPadron";
import { Notificar, CerrarNotificador } from "../../Comunes/Notificador";
import { ResultadosConsulta } from "./ResultadosConsulta";

class ParametrosPadron extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      datos: [],
      mostrarTabla: false,
    };
    this._onButtonClick = this._onButtonClick.bind(this);
  }

  ObtengaParametros() {
    let parametro = new SolicitudConsultaPadron();
    let identificacion = document.getElementById("Identificacion").value;
    let Nombre = document.getElementById("RazonSocial").value;
    let apellido1 = document.getElementById("PrimerApellido").value;
    let apellido2 = document.getElementById("SegundoApellido").value;

    parametro.PadronPersona = identificacion === "" ? null : identificacion;
    parametro.NombreORazonSocial = Nombre === "" ? null : Nombre;
    parametro.Apellido1 = apellido1 === "" ? null : apellido1;
    parametro.Apellido2 = apellido2 === "" ? null : apellido2;

    return parametro;
  }

  limpiarFiltros() {
    document.getElementById("Identificacion").value = "";
    document.getElementById("RazonSocial").value = "";
    document.getElementById("PrimerApellido").value = "";
    document.getElementById("SegundoApellido").value = "";
  }

  cargarResultados = async () => {
    let parametro = this.ObtengaParametros();
    let resultado = await ServicioPadron.ConsultaPadron(parametro);

    if (resultado.EsValido) {
      this.setState({
        datos: resultado.Personas,
        mostrarTabla: true,
      });
      CerrarNotificador();
    } else {
      this.setState({ mostrarTabla: false });
      Notificar("error", resultado.Errores);
    }
  };

  async _onButtonClick() {
    await this.cargarResultados();
  }

  render() {
    return (
      <div>
        <div>
          <div className="card shadow mb-4">
            <div className="card-header">
              <h6 className="m-0 font-weight-bold text-primary">
                Filtros de Búsqueda
              </h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="form-group col-md-3">
                  <label htmlFor="Identificacion" aria_label="Identificación">
                    Identificación{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="Identificacion"
                  />
                </div>
                <div className="form-group col-md-3">
                  <label
                    htmlFor="RazonSocial"
                    aria_label="Nombre Completo o Razón Social"
                  >
                    Nombre Completo o Razón Social
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="RazonSocial"
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="PrimerApellido" aria_label="Primer Apellido">
                    Primer Apellido
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="PrimerApellido"
                  />
                </div>
                <div className="form-group col-md-3">
                  <label
                    htmlFor="SegundoApellido"
                    aria_label="Segundo Apellido"
                  >
                    Segundo Apellido
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="SegundoApellido"
                  />
                </div>
              </div>
              <div className="row col-sm-12">
                <button
                  id="btnBuscarIdentificaciones"
                  onClick={this._onButtonClick}
                  type="button"
                  className="btn btn-primary btn-icon-split"
                >
                  <span className="icon text-white-50">
                    <i className="fas fa-search"></i>
                  </span>
                  <span className="text">Buscar</span>
                </button>

                <button
                  id="btnLimpiarFiltros"
                  onClick={this.limpiarFiltros}
                  type="button"
                  className="btn btn-sm btn-light ml-3"
                >
                  <i className="fas fa-redo fa-sm mr-1"></i>
                  Limpiar filtros
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          {this.state.mostrarTabla ? (
            <ResultadosConsulta datos={this.state.datos} />
          ) : null}
        </div>
      </div>
    );
  }
}

export default ParametrosPadron;
